import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '@/layout/Layout.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/Login.vue')
  },
  {
    path: '/',
    component: Layout,
    redirect: (to) => {
      const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}')
      const permCodes = userInfo.permCodes || []
      if (permCodes.includes('personalHomepage:view') || userInfo.userId === 1) {
        return '/personalHomepage'
      }
      // 如果没有首页权限，尝试跳转到第一个有权限的路由
      if (permCodes.includes('goods:view')) return '/products'
      if (permCodes.includes('order:view')) return '/orders'
      return '/personalHomepage' // 默认还是 dashboard，但会被守卫拦截
    },
    children: [
      {
        path: 'personalHomepage',
        name: 'PersonalHomepage',
        component: () => import('@/views/PersonalHomepage.vue'),
        meta: { title: '个人主页'}
      },
      {
        path: 'dataOverview',
        name: 'DataOverview',
        component: () => import('@/views/DataOverview.vue'),
        meta: { title: '数据看板'}
      },
      {
        path: 'products',
        name: 'Products',
        component: () => import('@/views/ProductManage.vue'),
        meta: { title: '商品管理'}
      },
      {
        path: 'product-categories',
        name: 'ProductCategories',
        component: () => import('@/views/ProductCategoryManage.vue'),
        meta: { title: '分类管理'}
      },
      {
        path: 'orders',
        name: 'Orders',
        component: () => import('@/views/OrderManage.vue'),
        meta: { title: '订单管理'}
      },
      {
        path: 'productionOrders',
        name: 'ProductionOrders',
        component: () => import('@/views/ProductionOrderManage.vue'),
        meta: { title: '生产备货'}
      },
      {
        path: 'outboundStocking',
        name: 'OutboundStocking',
        component: () => import('@/views/OutboundStocking.vue'),
        meta: { title: '海外备货'}
      },
      {
        path: 'warehouseGroup',
        name: 'WarehouseGroup',
        component: () => import('@/views/WarehousesGroup.vue'),
        meta: { title: '仓库分组'}
      },
      {
        path: 'warehouses',
        name: 'Warehouses',
        component: () => import('@/views/WarehouseManage.vue'),
        meta: { title: '仓库管理'}
      },
      {
        path: 'stockLocationManage',
        name: 'StockLocationManage',
        component: () => import('@/views/StockLocationManage.vue'),
        meta: { title: '库位管理'}
      },
      {
        path: 'inboundOrders',
        name: 'InboundOrders',
        component: () => import('@/views/InboundOrder.vue'),
        meta: { title: '入库单'}
      },
      {
        path: 'outboundOrder',
        name: 'OutboundOrder',
        component: () => import('@/views/OutboundOrder.vue'),
        meta: { title: '出库单'}
      },
      {
        path: 'returnedRecords',
        name: 'ReturnedRecords',
        component: () => import('@/views/ReturnedRecord.vue'),
        meta: { title: '回货记录'}
      },
      {
        path: 'inventory',
        name: 'Inventory',
        component: () => import('@/views/InventoryManage.vue'),
        meta: { title: 'SKU库存'}
      },
      {
        path: 'wmsInventoryStock',
        name: 'WmsInventoryStock',
        component: () => import('@/views/WmsInventoryStock.vue'),
        meta: { title: 'WMS库存'}
      },
      {
        path: 'userInventory',
        name: 'userInventory',
        component: () => import('@/views/UserInventoryManage.vue'),
        meta: { title: '库存管理'}
      },
      {
        path: 'userInventoryDetailManage',
        name: 'userInventoryDetailManage',
        component: () => import('@/views/UserInventoryDetailManage.vue'),
        meta: { title: '库存明细'}
      },
      {
        path: 'lockUpRecord',
        name: 'lockUpRecord',
        component: () => import('@/views/LockUpRecord.vue'),
        meta: { title: '锁仓记录'}
      },
      {
        path: 'withdraws',
        name: 'FundWithdraws',
        component: () => import('@/views/FundWithdrawRecords.vue'),
        meta: { title: '分销商提现记录'}
      },
      {
        path: 'wallet-logs',
        name: 'FundWalletLogs',
        component: () => import('@/views/FundWalletLogs.vue'),
        meta: { title: '分销商资金流水'}
      },
      {
        path: 'distributorBill',
        name: 'DistributorBill',
        component: () => import('@/views/DistributorBill.vue'),
        meta: { title: '分销商账单'}
      },
      {
        path: 'salesman-withdraws',
        name: 'SalesmanWithdraws',
        component: () => import('@/views/SalesmanWithdrawRecords.vue'),
        meta: { title: '渠道商务提现记录'}
      },
      {
        path: 'salesman-wallet-logs',
        name: 'SalesmanWalletLogs',
        component: () => import('@/views/SalesmanWalletLogs.vue'),
        meta: { title: '渠道商务资金流水'}
      },
      {
        path: 'supplierWalletLog',
        name: 'SupplierWalletLog',
        component: () => import('@/views/SupplierWalletLog.vue'),
        meta: { title: '供应商资金流水'}
      },
      {
        path: 'supplierWithdraws',
        name: 'SupplierWithdraws',
        component: () => import('@/views/SupplierWithdraws.vue'),
        meta: { title: '供应商提现记录'}
      },
      {
        path: 'sub-accounts',
        name: 'SubAccounts',
        component: () => import('@/views/SubAccountManage.vue'),
        meta: { title: '子账号管理'}
      },
      {
        path: 'channel/distributors',
        name: 'DistributorManage',
        component: () => import('@/views/DistributorManage.vue'),
        meta: { title: '分销商管理'}// 2
      },
      {
        path: 'distributor-apply-records',
        name: 'DistributorApplyRecord',
        redirect: 'channel/distributors?tab=apply'
      },
      {
        path: 'channel/distributor-levels',
        name: 'DistributorLevels',
        component: () => import('@/views/DistributorLevelManage.vue'),
        meta: { title: '分销商等级管理'}// 2
      },
      {
        path: 'channel/salesman-levels',
        name: 'SalesmanLevels',
        component: () => import('@/views/SalesmanLevelManage.vue'),
        meta: { title: '渠道商务等级管理'}// 2
      },
      {
        path: 'channel/distributor-apply-audit',
        name: 'DistributorApplyAudit',
        component: () => import('@/views/DistributorApplyAudit.vue'),
        meta: { title: '分销商申请审核'}// 2
      },
      {
        path: 'channel/suppliers',
        name: 'Suppliers',
        component: () => import('@/views/SupplierManage.vue'),
        meta: { title: '供应商管理'}// 2
      },
      {
        path: 'salesmanManage',
        name: 'SalesmanManage',
        component: () => import('@/views/SalesmanManage.vue'),
        meta: { title: '渠道商务管理'}// 2
      },
      {
        path: 'system/permissions',
        name: 'PermissionManage',
        component: () => import('@/views/PermissionManage.vue'),
        meta: { title: '菜单管理'}//1
      },
      {
        path: 'system/roles',
        name: 'RoleManage',
        component: () => import('@/views/RoleManage.vue'),
        meta: { title: '角色管理'}//1
      },
      {
        path: 'system/users',
        name: 'UserManage',
        component: () => import('@/views/UserManage.vue'),
        meta: { title: '用户管理' }//1
      },
      {
        path: 'system/express-companies',
        name: 'ExpressCompanies',
        component: () => import('@/views/ExpressCompanyManage.vue'),
        meta: { title: '物流公司管理'}// 2
      },
      {
        path: 'system/provinces',
        name: 'Provinces',
        component: () => import('@/views/ProvinceManage.vue'),
        meta: { title: '省份管理'}// 2
      },
      {
        path: 'system/product-spec-options',
        name: 'ProductSpecOptions',
        component: () => import('@/views/ProductSpecOptionManage.vue'),
        meta: { title: '颜色尺码维护'}// 2
      },
      {
        path: 'temuProductSpecOptionManage',
        name: 'TemuProductSpecOptionManage',
        component: () => import('@/views/TemuProductSpecOptionManage.vue'),
        meta: { title: 'TEMU基础数据'}// 2
      },
      {
        path: 'system/ai-fee-dictionary',
        name: 'AiFeeDictionary',
        component: () => import('@/views/AiFeeDictionaryManage.vue'),
        meta: { title: 'AI扣费字典维护'}// 2
      },
      {
        path: 'ProductLabel',
        name: 'ProductLabel',
        component: () => import('@/views/ProductLabel.vue'),
        meta: { title: '标签管理'}// 2
      },
      {
        path: 'paymentConfig',
        name: 'Paymentconfig',
        component: () => import('@/views/Paymentconfig.vue'),
        meta: { title: '公司收款方式'}//
      },
      {
        path: 'rechargeRecord',
        name: 'RechargeRecord',
        component: () => import('@/views/RechargeRecord.vue'),
        meta: { title: '分销商充值记录'}//
      },
      {
        path: 'salesmanRechargeRecord',
        name: 'SalesmanRechargeRecord',
        component: () => import('@/views/SalesmanRechargeRecord.vue'),
        meta: { title: '渠道商务充值记录'}//
      },
      {
        path: 'shopManage',
        name: 'ShopManage',
        component: () => import('@/views/ShopManage.vue'),
        meta: { title: '店铺管理'}//
      },
      {
        path: 'temuOrder',
        name: 'TemuOrder',
        component: () => import('@/views/TemuOrder.vue'),
        meta: { title: 'TEMU平台单'}//
      },
      {
        path: 'temuProductCategoryManage',
        name: 'TemuProductCategoryManage',
        component: () => import('@/views/TemuProductCategoryManage.vue'),
        meta: { title: 'TEMU分类管理'}// 2
      },
      {
        path: 'ProductSalutationQueue',
        name: 'ProductSalutationQueue',
        component: () => import('@/views/ProductSalutationQueue.vue'),
        meta: { title: '自动上款记录'}// 2
      },
      {
        path: 'aiProductData',
        name: 'AiProductData',
        component: () => import('@/views/AiProductData.vue'),
        meta: { title: 'AI生成商品'}// 2
      },

      {
        path: 'purchaseOrder',
        name: 'PurchaseOrder',
        component: () => import('@/views/PurchaseOrder.vue'),
        meta: { title: '采购备货'}// 2
      },
      {
        path: 'dashboard',
        name: 'DataDashboard',
        component: () => import('@/views/dashboard/DashboardView.vue'),
        meta: { title: '经营数据总览' }
      },
      {
        path: 'exchangeResendOrder',
        name: 'ExchangeResendOrder',
        component: () => import('@/views/ExchangeResendOrder.vue'),
        meta: { title: '换单重发单' }
      },
      {
        path: 'productReport',
        name: 'ProductReport',
        component: () => import('@/views/ProductReport.vue'),
        meta: { title: '商品数据报表' }
      },

    ]
  }
]

const router = new VueRouter({
  routes
})

// 路由守卫
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token')

  if (to.path === '/login') {
    next()
  } else if (!token) {
    next('/login')
  } else {
    // 根路径直接放行，让 redirect 处理
    if (to.path === '/') {
      next()
      return
    }
    next()
  }
})

export default router
